export const statusItems = [
  { value: '', name: 'All statuses', active: false },
  { value: 0, name: 'Created', active: false },
  { value: 1, name: 'In process', active: false },
  { value: 2, name: 'Approved', active: false },
  { value: 3, name: 'Canceled', active: false },
];

export const itemsOnPage = 10;
